import React, { ReactElement, useEffect } from 'react';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { Button, LoaderButton } from 'idsk-react-components';
import PracovnyKrokRequest from '../../../../../../model/pracovnyKrok/PracovnyKrokRequest';
import { useClient, useClientStatusContext } from '../../../../../../context/ClientStatusContext';
import { sendBezPripomienok } from '../../../../../../client/external/pripomienky/sendBezPripomienokClient';
import { useSuccessMessageContext } from '../../../../../../context/SuccessMessageContext';
import LegislativnyMaterialItem from '../../../../../../model/pracovnyKrok/LegislativnyMaterialItem';
import {
  usePracovnyKrokLegislativnyMaterialContext,
} from '../../../../../../context/PracovnyKrokLegislativnyMaterialContext';
import splitCisloLegMaterialu from '../../../../../../function/splitCisloLegMaterialu';

interface Props {
  legMaterial: LegislativnyMaterialItem;
  pracovnyKrok: PracovnyKrokRequest;
  className?: string;
  reloadPracovneKroky: () => void;
  setIsDropdownOpened: (isDropdownOpened: boolean) => void,
}

const OdoslatBezPripomienok = ({
  pracovnyKrok,
  className,
  legMaterial,
  reloadPracovneKroky,
  setIsDropdownOpened,
}: Props): ReactElement => {
  const {
    handleStatus,
    clearStatus,
  } = useClientStatusContext();
  const {
    clearMessages,
    displaySuccess,
  } = useSuccessMessageContext();

  const {
    wrapClient: sendBezPripomienokClient,
    status: sendBezPripomienokStatus,
  } = useClient(sendBezPripomienok);

  const {
    setMaterial,
    setLoadingMaterial,
  } = usePracovnyKrokLegislativnyMaterialContext();
  const {
    type,
    year,
    index,
  } = splitCisloLegMaterialu(legMaterial.cisloLegislativnehoMaterialu);

  const odoslatBezPripomienok = async (): Promise<void> => {
    await sendBezPripomienokClient(type, year, index);

    reloadPracovneKroky();
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  const clearStatusAndMessages = (): void => {
    clearStatus();
    clearMessages();
  };

  useEffect(
    () => setMaterial(legMaterial),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [legMaterial?.uuid, legMaterial?.typ,
      legMaterial?.cisloLegislativnehoMaterialu, setMaterial],
  );

  useEffect(() => {
    setLoadingMaterial(sendBezPripomienokStatus?.loading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendBezPripomienokStatus?.loading]);

  useEffect(() => {
    if (sendBezPripomienokStatus?.responseCode === 403) {
      handleStatus(sendBezPripomienokStatus);
    }
  }, [sendBezPripomienokStatus, handleStatus]);

  return (
    <>
      <ConfirmModal
        question='Naozaj si prajete odoslať stanovisko Vašej organizácie „Bez pripomienok"?'
        description={'Po odoslaní stanoviska „Bez pripomienok" už Vaša organizácia nebude môcť v tomto PK '
          + 'vytvoriť a odoslať žiadne pripomienky.'}
        cancelButtonText="Nie"
        confirmButton={
          (
            <Button
              buttonStyle="action"
              size="large"
            >
              Áno
            </Button>
          )
        }
        openButton={(
          <LoaderButton
            className={className}
            loading={sendBezPripomienokStatus.loading}
            buttonStyle="link"
            onClick={() => {
              clearStatusAndMessages();
              setIsDropdownOpened(false);
            }}
            size="small"
            disableOutsideClickWhileLoading
          >{pracovnyKrok.nazov}
          </LoaderButton>
        )}
        doAfterConfirm={() => odoslatBezPripomienok()}
      />
    </>
  );
};

export default OdoslatBezPripomienok;
